import { ComponentResolver } from '@aspendental/shared-components-web';
import { ImagePriorityContext } from '@aspendental/shared-components-web/lib/utils/images/imageOptimization';
import { IGoogleMap } from '@aspendental/shared-components-web/lib/components/GoogleMap/GoogleMap';
import { Maybe, Provider, ProviderDetailsPageContentsCollection, ProviderDetailsPageContentsItem, ProviderDetailsPageSecondaryContentsCollection, ProviderDetailsPageSecondaryContentsItem } from '../../lib/__generated/sdk';
import ProviderAbout from './ProviderAbout';
import ProviderHero from './ProviderHero';
import ProviderInsurance from './ProviderInsurance';
import ProviderOffices from './ProviderOffices';
export interface ExtendedProvider extends Provider {
  providerImages: {
    url: string;
  }[];
}
export interface IProviderDetailsPage {
  provider: ExtendedProvider;
  config: BrandThemeConfig;
  contentsCollection?: Maybe<ProviderDetailsPageContentsCollection>;
  secondaryContentsCollection?: Maybe<ProviderDetailsPageSecondaryContentsCollection>;
  tagTheme?: TagThemeType;
  showProviderPageInsuranceInfo?: boolean;
  googleMapsData?: IGoogleMap;
}
export default function ProviderDetailsPage({
  provider,
  config,
  contentsCollection,
  secondaryContentsCollection,
  tagTheme,
  showProviderPageInsuranceInfo = false,
  googleMapsData
}: Readonly<IProviderDetailsPage>) {
  return <>
			<ImagePriorityContext.Provider value={0} data-sentry-element="ImagePriorityContext.Provider" data-sentry-source-file="ProviderDetailsPage.tsx">
				<ProviderHero provider={provider} config={config} data-sentry-element="ProviderHero" data-sentry-source-file="ProviderDetailsPage.tsx" />
			</ImagePriorityContext.Provider>
			{provider.biography && <ProviderAbout provider={provider} config={config} />}
			{/* <ProviderSpecialties /> */}
			{contentsCollection?.items?.map((content: Maybe<ProviderDetailsPageContentsItem>, index: number) => {
      if (!content?.__typename || Object.keys(content).length <= 2) {
        console.warn(`⚠️⚠️⚠️ Shared Components Web - Provider Details Page - NPI - ${provider.npi || ''} - Content - No content __typename found for ${content?.sys?.id || 'Unknown entryId'} ⚠️⚠️⚠️`);
        return null;
      }
      return <ComponentResolver key={`${content.sys.id}-${content.__typename}-${index}`}
      // @ts-ignore
      componentProps={content} typename={content.__typename} />;
    })}
			{provider && Array.isArray(provider?.providerLocations) && (provider?.providerLocations || []).length > 0 && <ProviderOffices provider={provider} config={config} tagTheme={tagTheme} googleMapsData={googleMapsData} />}
			{showProviderPageInsuranceInfo && <ProviderInsurance provider={provider} config={config} />}
			{secondaryContentsCollection?.items?.map((content: Maybe<ProviderDetailsPageSecondaryContentsItem>, index: number) => {
      if (!content?.__typename || Object.keys(content).length <= 2) {
        console.warn(`⚠️⚠️⚠️ Shared Components Web - Provider Details Page - NPI - ${provider.npi || ''} - Secondary Content - No content __typename found for ${content?.sys?.id || 'Unknown entryId'} ⚠️⚠️⚠️`);
        return null;
      }

      // @ts-ignore
      return <ComponentResolver key={`${content.sys.id}-${content.__typename}-${index}`}
      // @ts-ignore
      componentProps={content} typename={content.__typename} />;
    })}
		</>;
}